import React, {useState, useEffect, useRef} from "react";
import {Card} from 'antd';
import GenericDialog from '../common/GenericDialog';
import axios from "../common/axios";
import CircularLoader from "../common/CircularLoader";
import {GlossaryHead, GlossaryTerm} from "./GlossaryTerm";

const GlossaryTermDialog = props => {
    const {open = false, onClose, glossaryTermId} = props;
    const [glossaryTerm, setGlossaryTerm] = useState();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState();

    const loadGlossaryTerm = (glossaryTermId) => {
        setLoading(true);
        axios.get('/web/ui/glossary/glossaryTerm', {params: {glossaryTermId: glossaryTermId }})
            .then(response => {
                if(response.data) {
                    setGlossaryTerm(response.data);
                }
                setLoading(false);
            }).catch(error => {
            console.error(error);
            setError('Error loading dictionary terms');
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleLinkClick = (event) => {
        event.preventDefault();
        const glossaryTermId = event.currentTarget.getAttribute('value');
        if(glossaryTermId) {
            loadGlossaryTerm(glossaryTermId);
        }
    };

    useEffect(() => {
        if(!open || !glossaryTermId) {
            return;
        }
        loadGlossaryTerm(glossaryTermId);
    }, [open, glossaryTermId]);

    return (
        <GenericDialog
            open={open}
            fullWidth={true}
            maxWidth={'md'}
            isLoading={isLoading}
            onClose={onClose}
            buttons={[{name: 'Close'}]}
        >
            <Card title={glossaryTerm && <GlossaryHead glossaryTerm={glossaryTerm}/>} style={{width: '100%'}}>
                {glossaryTerm &&
                    <GlossaryTerm glossaryTerm={glossaryTerm} onLinkClick={handleLinkClick}/>
                }
                <CircularLoader visible={isLoading}/>
            </Card>
        </GenericDialog>
    )
}

export default GlossaryTermDialog;
